import { API_BASE_URL } from '@synergy/config';
import { createAction } from '@reduxjs/toolkit';
import { nullIfEmpty } from '@synergy/utils';

import { AppDispatch, AppState } from '../../store/store';
import { PoolSnackbar } from '../components/snackbars/pool-snackbar';
import { SingleInquiryApi } from '../api/single-inquiry-api';
import { SingleInquiryFormValues } from '../pages/modals/single-inquiry/models/single-inquiry-form-values';
import { SingleInquiryRequest } from '../api/models/single-inquiry-request';
import { enqueueSnackbar } from './snackbar-actions';

const api = new SingleInquiryApi(API_BASE_URL);

export const openInquiryModal = createAction<Partial<SingleInquiryFormValues> | undefined>('single-inquiry/open-modal');
export const closeInquiryModal = createAction('single-inquiry/close-modal');

export const sendSingleInquiry =
    (values: SingleInquiryFormValues) => async (dispatch: AppDispatch, _getState: () => AppState) => {
        const request: SingleInquiryRequest = {
            items: values.items
                .filter(item => item.quantity)
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                .map(item => ({ articleName: item.articleName, quantity: item.quantity! })),
            noteFromCustomer: nullIfEmpty(values.noteFromCustomer),
            deliveryAddressId: values.deliveryAddressId,
            desiredDeliveryDate: values.deliveryDate ? values.deliveryDate.toDate() : null,
            isDesiredDeliveryDateFrom: true, // TODO
            files: values.files,
        };

        const response = await api.sendSingleInquiry(request);
        // TODO
        if (response.success) {
            dispatch(enqueueSnackbar(PoolSnackbar.success('app.singleInquiry.sent')));
        } else {
            dispatch(enqueueSnackbar(PoolSnackbar.error('app.error.general')));
        }
    };
